import {FieldRenderProps} from "@progress/kendo-react-form"
import {NumericTextBox, NumericTextBoxBlurEvent, NumericTextBoxChangeEvent} from "@progress/kendo-react-inputs"
import React, {useRef} from "react"

const NumberInputField = (fieldRenderProps: FieldRenderProps) => {
    const {name, label, disabled, value, onChange, updateTotalAmount = null} = fieldRenderProps
    const inputRef = useRef<any>(null)
    const onAdjustmentCostChange = React.useCallback(
        (event: NumericTextBoxBlurEvent) => {
            if (name === "laneFee") {
                updateTotalAmount(event.target.value || 0)
            }
        },
        [name],
    )

    const onNumberChange = (event: NumericTextBoxChangeEvent) => {
        if (name === "laneFee") {
            onChange(event)
            event.target.focus()
        }
    }

    return (
        <NumericTextBox
            ref={inputRef}
            spinners={false}
            id={`bk_numinput_${name}`}
            name={name}
            label={label}
            value={value}
            onChange={onNumberChange}
            onBlur={onAdjustmentCostChange}
            disabled={disabled}
            format="c2"
        />
    )
}

export default React.memo(NumberInputField)
